import { clsx } from "clsx";
import Color from "color";
import React from "react";
import type { Project } from "../../../state/workspaces/types";
import Styles from "./ProjectPill.module.css";

export const ProjectPill = ({ project }: { project: Project }) => {
  const backgroundColor = Color(project.color || "lightgrey");

  return (
    <div
      className={clsx(
        Styles.projectPill,
        backgroundColor.isDark() ? "theme-dark" : "theme-light",
      )}
      style={{
        "--background-color": project.color ?? "",
      }}
    >
      <span className={`hoylu-ui-icons-${project.icon}`} />
      <span>{project.name}</span>
    </div>
  );
};
